export function introScene(k) {
    k.add([
        k.rect(k.width(), k.height()),
        k.color(0, 0, 0),
    ]);

    // Create the HTML video element & reigster it on page
    const video = document.createElement("video");
    video.src = "/videos/intro.mp4";
    video.style.position = "absolute";
    video.style.top = "0";
    video.style.left = "0";
    video.style.width = "100%";
    video.style.height = "100%";
    video.style.objectFit = "contain";
    video.style.zIndex = "5"; // Sit above the canvas initially
    document.body.appendChild(video);

    // Play video and handle errors
    video.play().catch((error) => {
        console.warn("Video playback failed, skipping to menu:", error);
        goToMenuWithFade();
    });

    let isFading = false;
    const goToMenuWithFade = () => {
        if (isFading) return; // Prevent double-clicks during the fade
        isFading = true;

        // Tween the HTML element's CSS opacity
        k.tween(
            1,
            0,
            1.5,
            (val) => {
                video.style.opacity = val;
            },
            k.easings.easeInQuad
        );

        k.wait(1.7, () => {
            video.pause();
            video.remove();
            k.go("menu");
        });
    };

    video.onended = goToMenuWithFade;
    video.onclick = goToMenuWithFade;
}